webpackJsonp([253939972072432],{

/***/ 424:
/***/ (function(module, exports) {

	module.exports = {"data":{"markdownRemark":{"html":"<p>I just want to write to my Blog followers and notify you all that I have been relatively busy lately and that is the reason for lack of any posts. I have just been employed by a company called <a href=\"https://createanet.co.uk\">CreateANet</a>. They specialise in app development, so it's an exciting time for me and my future. I have been settling in for the past couple of weeks and all seems to be going well thus far.</p>\n<p>I am also taking a week off work this week to look after my mum, it may give me some free time to create a few tutorial posts and I should be able to continue with the oauth stuff which I have been promising for my readers.</p>\n<p>Any requests, please post in the comments below and I look forward to speaking to you guys soon.</p>","frontmatter":{"categories":["General Updates"],"date":"May 11, 2015","featuredImage":"placeholder.png","title":"May Update"}}},"pathContext":{"slug":"/may-update/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---post-may-update-9cce4ff5cd2e78381d92.js